import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ForecastElementAdjustmentRoutingModule } from './forecast-element-adjustment-routing.module';
import { ForecastElementAdjustmentComponent } from './forecast-element-adjustment.component';
import { DxDataGridModule, DxTextAreaModule, DxPopupModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';


@NgModule({
  declarations: [ForecastElementAdjustmentComponent],
  imports: [
    CommonModule,
    ForecastElementAdjustmentRoutingModule,
    DxDataGridModule,
    DevEpressCommonModule,
    DxTextAreaModule,
    DxPopupModule,
	DxTableControllerDirective,
  ]
})
export class ForecastElementAdjustmentModule { }
